// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2GtDh","Label":"Input_Label__2GdGB","InputElement":"Input_InputElement__2r9XP","Invalid":"Input_Invalid__1VGio"};